import { DynamicModal } from "src/components/base/components/DynamicModal";
import { createState } from "src/utils/create_zustand_store";
import { useRouterExt } from "../../hooks/useRouterExt";
import { routes } from "src/shared/routes";
import { TmAccountDetails } from "../TmAccountDetails";
import { Box } from "@mui/material";
import { useGroupInviteFlow } from "src/components/feature/groupInviteFlow/useGroupInviteFlow";
import React from "react";
import { TGroupDetails } from "src/shared/types/globalStotre.types";
import { isUserGroupLeader } from "src/utils/utils";
import { useGlobalStore } from "../../hooks/useGlobalStore";

export const useLeaveGroupConfirmModal = createState({
  isOpen: false,
  groupDetails: null as TGroupDetails | null,
  onConfirm: async () => {},
});

export function LeaveGroupConfirmModal() {
  const router = useRouterExt();
  const modalState = useLeaveGroupConfirmModal();
  const { user } = useGlobalStore();
  const isGroupLeader = isUserGroupLeader(modalState?.groupDetails, user);
  const [isConfirming, setIsConfirming] = React.useState(false);

  const onClose = () => {
    modalState.reset();
  };

  return (
    <DynamicModal
      isOpen={modalState.isOpen}
      title="Leave Group"
      description={
        <Box py={1}>
          {isGroupLeader
            ? "You are the Group Leader. By leaving this group, the role of Group Leader will be transferred to the next group member. You can be invited back to this group but you will no longer be the Group Leader."
            : "Are you sure want to leave this group?"}
        </Box>
      }
      onClose={onClose}
      slot={{
        primaryButton: {
          label: "Leave Group",
          isLoading: isConfirming,
          isDisabled: isConfirming,
          onClick: async () => {
            setIsConfirming(true);
            await modalState.onConfirm();
            setIsConfirming(false);
            onClose();
          },
        },
        secondaryButton: {
          label: "Cancel",
          onClick: () => onClose(),
        },
      }}
    />
  );
}
